export default __webpack_public_path__ + "static/media/aloyaux.fe7c961c.jpg";